export default __webpack_public_path__ + "static/media/starter-pack-1-badge.65eb08e1.png";